module.exports = __webpack_public_path__ + "static/media/firstoeat-logo.a9576549.svg";